import { Phone } from "lucide-react";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const FooterInternationalHelp = ({ phone, whatsapp }) => (
  <section
    data-testid="footer-international-help"
    aria-labelledby="footer-international-help-heading"
    className="mt-7 border-t border-[#2F4A26]/15 pt-6"
  >
    <h2
      id="footer-international-help-heading"
      data-testid="footer-international-help-heading"
      translate="no"
      className="notranslate font-sans text-base font-medium leading-snug tracking-normal text-[#2F4A26] mb-3"
    >
      International Customer Help
    </h2>
    <div className="space-y-1 text-sm text-[#1A1715]">
      <a
        data-testid="footer-international-phone"
        href={`tel:${phone.replace(/\s/g, "")}`}
        aria-label={`International Customer Help — Phone: ${phone}`}
        className="flex items-center gap-2.5 py-1.5 hover:text-[#2F4A26] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#7BA05B] transition-colors"
      >
        <Phone size={14} strokeWidth={1.75} className="shrink-0 text-[#2F4A26]" aria-hidden="true" />
        <span className="whitespace-nowrap">{phone}</span>
      </a>
      <a
        data-testid="footer-international-whatsapp"
        href={`https://wa.me/${whatsapp.replace(/[^0-9]/g, "")}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`International Customer Help — WhatsApp: ${whatsapp}`}
        className="flex items-center gap-2.5 py-1.5 hover:text-[#25D366] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#7BA05B] transition-colors"
      >
        <WhatsAppIcon size={14} className="shrink-0 text-[#2F4A26]" />
        <span className="whitespace-nowrap">{whatsapp}</span>
      </a>
    </div>
  </section>
);